import { createContext, ReactNode, useContext } from "react";
import { Brand, Product } from "@cerberus/branding";
import { getActiveBrand } from "./activeBrand";

const BrandingContext = createContext<Brand>(getActiveBrand());

/**
 * Provides the active deployment brand to the component tree. The brand is fixed
 * per deployment (selected via `window.runConfig.brand`), so it's resolved once.
 */
export function BrandingProvider({ children }: { children: ReactNode }) {
  return (
    <BrandingContext.Provider value={getActiveBrand()}>
      {children}
    </BrandingContext.Provider>
  );
}

/** Access the active brand (name, logos, copyright, palette, …) in a component. */
export function useBranding(): Brand {
  return useContext(BrandingContext);
}

/**
 * Is this deployment the given product (or one of them)? The hook form of `isActiveProduct`, for
 * branching on TeleHeadache vs CerebraLinked inside a component. Prefer this over comparing brand
 * keys: `mtc` and `cerebralinked` are both CerebraLinked.
 */
export function useIsProduct(product: Product | Product[]): boolean {
  const { product: active } = useBranding();
  return Array.isArray(product) ? product.includes(active) : active === product;
}
